
export function setCookieData(key: string, value: object, days = 1) {
  const json = JSON.stringify(value);
  const encoded = encodeURIComponent(json);
  const expiresDate = new Date(Date.now() + days * 864e5).toUTCString();

  document.cookie = [
    `${key}=${encoded}`,
    `expires=${expiresDate}`,
    'path=/',
    'SameSite=Lax',
  ].join('; ');
}

export function getCookieData(key: string) {
  const cookieMap = document.cookie
    .split('; ')
    .map(pair => pair.split('='))
    .reduce((acc, [k, v]) => {
      acc[k] = v;
      return acc;
    }, {});

  if (!(key in cookieMap)) return null;

  try {
    const decoded = decodeURIComponent(cookieMap[key]);
    return JSON.parse(decoded);
  } catch (err) {
    console.error(`Error parsing cookie "${key}":`, err);
    return null;
  }
}

export function getCookie(key: string) {
  const cookieMap = document.cookie
    .split('; ')
    .map(pair => pair.split('='))
    .reduce((acc, [k, v]) => {
      acc[k] = v;
      return acc;
    }, {});

  if (!(key in cookieMap)) return null;

  try {
    const decoded = decodeURIComponent(cookieMap[key]);
    return decoded;
  } catch (err) {
    console.error(`Error parsing cookie "${key}":`, err);
    return null;
  }
}

export function setCookie(key: string, value: string, days = 1) {
  const expiresDate = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = [
    `${key}=${value}`,
    `expires=${expiresDate}`,
    'path=/',
    'SameSite=Lax',
  ].join('; ');
}

// delete cookie
export function deleteCookie(key: string) {
  document.cookie = `${key}=; Max-Age=0; path=/; SameSite=Lax`;
}

/**
 * GoHighLevel / LeadConnector session tokens. GHL's SSO sets these on the shared
 * parent domain (.authorify.com), without HttpOnly and with a ~1 year TTL, so the
 * browser ships all of them (~5.6KB) to crm.authorify.com on every request. Once
 * they accumulate (v1 + v2 + rotated copies) the request headers exceed the
 * Cloudflare/nginx limit and crm responds 431 (Request Header Fields Too Large).
 * afy-ui never reads these (it authenticates via localStorage), so clearing them
 * is safe and forces a fresh, small set on the next Marketing Hub launch.
 */
export const GHL_SESSION_COOKIES = [
  'access-token-v1',
  'access-token-v2',
  'refresh-token-v1',
  'refresh-token-v2',
  'custom-firebase-token',
  'm_a',
  'a',
];

/**
 * Expires a cookie regardless of the scope it was set with. `document.cookie`
 * never exposes a cookie's Domain attribute, so we issue an expiry for the
 * host-only scope and for every parent domain of the current host; the browser
 * deletes whichever one actually matches (the GHL tokens live on .authorify.com).
 */
export function deleteCookieAllScopes(key: string) {
  const { hostname } = window.location;
  const parts = hostname.split('.');

  // host-only (no domain attribute) + the exact host
  const domains = new Set([undefined, hostname]);

  // parent domains: app.authorify.com -> .authorify.com (never the bare TLD)
  for (let i = 1; i < parts.length - 1; i += 1) {
    domains.add(`.${parts.slice(i).join('.')}`);
  }

  domains.forEach((domain) => {
    const segments = [`${key}=`, 'Max-Age=0', 'path=/', 'SameSite=Lax'];
    if (domain) segments.push(`domain=${domain}`);
    document.cookie = segments.join('; ');
  });
}

/**
 * Clears the bloated GHL/LeadConnector session cookies (see GHL_SESSION_COOKIES).
 * Call from the login page so each fresh sign-in starts with a clean cookie slate
 * and Marketing Hub re-mints small tokens via SSO.
 */
export function clearGhlSessionCookies() {
  GHL_SESSION_COOKIES.forEach(deleteCookieAllScopes);
}
